<template>
  <div class="step-wrapper">
    <Navbar />
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6 col-sm-12 left-col">
          <div class="event-info">
            <h6>Webinar Girişi</h6>
            <h2 class="event-title">{{$root.event.title}}</h2>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 right-col">
          <div class="step-content">
            <Step1 v-if="step==1" />
            <Step2 v-if="step==2" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Step1 from "@/components/Step1.vue";
import Step2 from "@/components/Step2.vue";
export default {
  data() {
    return {
      step: 1
    };
  },
  computed: {},
  components: {
    Navbar,
    Step1,
    Step2
  },
  created() {
    if (!this.$root.step) {
      this.$router.push("/" + this.$root.event.shortLink);
    }
  }
};
</script>

<style lang="scss">
.event-title {
  color: #878280;
  padding-bottom: 48px;
}
.event-info {
  padding: 30px;
}
.step-wrapper {
  .row {
  }
}
.left-col {
  background-color: #fff;
  display: flex;
  align-items: center;
}
.right-col {
  background-color: #fafaf8;
  padding: 60px;
}

@media (min-width: 768px) {
  .right-col {
    height: calc(100vh - 72px);
    overflow: hidden;
    overflow-y: scroll;
  }
}
</style>